import React from "react";
import { createPortal } from "react-dom";
import { FaTimes } from "react-icons/fa";

const ResendCareSupportNotificationModal = ({
  patient,
  appAccess,
  onClose,
  onConfirm,
  isSubmitting,
}) => {
  if (!patient) return null;

  return createPortal(
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0, 0, 0, 0.45)",
        zIndex: 1070,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "16px",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          backgroundColor: "#FFFFFF",
          borderRadius: "12px",
          width: "440px",
          maxWidth: "100%",
          boxShadow: "0 20px 60px rgba(0, 0, 0, 0.18)",
          overflow: "hidden",
          fontFamily: "Poppins, sans-serif",
        }}
      >
        <div
          style={{
            backgroundColor: "#0A3652",
            padding: "18px 24px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <h3 style={{ margin: 0, fontSize: "16px", fontWeight: 700, color: "#FFFFFF" }}>
            Resend Care Support Notification
          </h3>
          <button
            type="button"
            onClick={onClose}
            disabled={isSubmitting}
            style={{
              background: "none",
              border: "none",
              cursor: isSubmitting ? "not-allowed" : "pointer",
              color: "#FFFFFF",
              padding: "2px",
              display: "flex",
              opacity: isSubmitting ? 0.6 : 1,
            }}
          >
            <FaTimes size={16} />
          </button>
        </div>

        <div style={{ padding: "24px" }}>
          <p style={{ margin: "0 0 16px 0", fontSize: "14px", color: "#4B5563", lineHeight: 1.6 }}>
            Resend the Care Manager support email and push notification (if available) to this linked
            app user?
          </p>

          <div
            style={{
              backgroundColor: "#F8F9FA",
              borderRadius: "8px",
              padding: "16px",
              marginBottom: "24px",
            }}
          >
            <div style={{ marginBottom: "10px" }}>
              <div style={{ fontSize: "11px", color: "#8E8E93", marginBottom: "2px" }}>Patient</div>
              <div style={{ fontSize: "14px", fontWeight: 600, color: "#064260" }}>{patient.name}</div>
            </div>
            <div style={{ marginBottom: "10px" }}>
              <div style={{ fontSize: "11px", color: "#8E8E93", marginBottom: "2px" }}>Email</div>
              <div style={{ fontSize: "14px", fontWeight: 600, color: "#064260" }}>{patient.email}</div>
            </div>
            <div>
              <div style={{ fontSize: "11px", color: "#8E8E93", marginBottom: "2px" }}>
                Current Notification Status
              </div>
              <div style={{ fontSize: "14px", fontWeight: 600, color: "#064260" }}>
                {appAccess?.notificationStatus || "—"}
              </div>
            </div>
          </div>

          <div style={{ display: "flex", gap: "12px", justifyContent: "flex-end" }}>
            <button
              type="button"
              onClick={onClose}
              disabled={isSubmitting}
              style={{
                padding: "10px 20px",
                borderRadius: "8px",
                border: "1px solid #EAECEF",
                backgroundColor: "#FFFFFF",
                color: "#064260",
                fontWeight: 600,
                fontSize: "14px",
                cursor: isSubmitting ? "not-allowed" : "pointer",
              }}
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={onConfirm}
              disabled={isSubmitting}
              style={{
                padding: "10px 24px",
                borderRadius: "8px",
                border: "none",
                backgroundColor: "#27B99A",
                color: "#FFFFFF",
                fontWeight: 600,
                fontSize: "14px",
                cursor: isSubmitting ? "not-allowed" : "pointer",
                opacity: isSubmitting ? 0.7 : 1,
              }}
            >
              {isSubmitting ? "Sending…" : "Resend Notification"}
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default ResendCareSupportNotificationModal;
